var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#F3F3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 27.5052C10.4189 27.9223 10.4636 28.5539 10.8807 28.9159C11.2978 29.2779 11.9293 29.2333 12.2914 28.8162L10.7809 27.5052ZM28.1408 10.108C28.1018 9.55713 27.6237 9.14211 27.0727 9.18106L18.0952 9.81584C17.5442 9.85479 17.1292 10.333 17.1682 10.8839C17.2071 11.4348 17.6853 11.8498 18.2362 11.8109L26.2163 11.2466L26.7805 19.2267C26.8195 19.7776 27.2977 20.1926 27.8486 20.1537C28.3995 20.1147 28.8145 19.6365 28.7756 19.0856L28.1408 10.108ZM12.2914 28.8162C15.3388 25.305 19.2406 20.8094 22.3805 17.1917C23.9505 15.3828 25.33 13.7934 26.317 12.6562C26.8105 12.0876 27.2059 11.6321 27.4779 11.3187C27.6139 11.162 27.719 11.0408 27.7902 10.9588C27.8257 10.9179 27.8528 10.8866 27.871 10.8657C27.8801 10.8552 27.887 10.8473 27.8916 10.842C27.8939 10.8394 27.8956 10.8374 27.8968 10.836C27.8973 10.8354 27.8978 10.8349 27.8981 10.8345C27.8982 10.8344 27.8983 10.8343 27.8984 10.8342C27.8985 10.8341 27.8985 10.834 27.1433 10.1786C26.3881 9.5231 26.388 9.52314 26.3879 9.52322C26.3879 9.52331 26.3878 9.52343 26.3876 9.5236C26.3873 9.52395 26.3869 9.52441 26.3863 9.5251C26.3852 9.52643 26.3834 9.52842 26.3811 9.53107C26.3765 9.53636 26.3697 9.54428 26.3606 9.55475C26.3424 9.5757 26.3153 9.6069 26.2797 9.6479C26.2086 9.72988 26.1034 9.85104 25.9674 10.0077C25.6954 10.3211 25.3 10.7767 24.8065 11.3453C23.8195 12.4825 22.4401 14.0719 20.8701 15.8807C17.7302 19.4985 13.8284 23.994 10.7809 27.5052L12.2914 28.8162Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderArrow);
export default __webpack_public_path__ + "static/media/header-arrow.a92ec7247b88ea70663f57e68437d010.svg";
export { ForwardRef as ReactComponent };